// utils/fileTypeDetector.ts
export const getFileType = (fileName: string): "CSV" | "EXCEL" => {
  const extension = fileName.split(".").pop()?.toLowerCase();

  if (extension === "csv") {
    return "CSV";
  }

  // Common Excel file extensions
  if (["xls", "xlsx", "xlsm", "xlsb"].includes(extension || "")) {
    return "EXCEL";
  }

  // Default to CSV if unknown extension
  return "CSV";
};
